<template>
   <div>
       <div class="breadcrumb">
            <div class="container">
                <button
                    @click="clearSearch()" 
                    v-show="!!searchQuery.length && searchQuery != ' '"
                    class="btn btn-primary">На главную</button>
                <form 
                    class="btn-group float-right" 
                    @submit.prevent="refreshList()"
                    ref="searchForm"
                    >
                    <input 
                        type="text" 
                        class="form-control" 
                        placeholder="Поиск"
                        v-model.lazy="search"
                        >
                    <button 
                        type="submit"
                        class="btn btn-primary">Искать</button>
                </form>
            </div>
           </div>
        <div class="container">
            <div class="row loading" v-show="!loading">
                <show-list-item
                    v-for="item in showsList"
                    :show="item"
                    v-show="!!showsList.length"
                    ></show-list-item>
                <div 
                    v-show="!showsList.length && !!search.length"
                    class="card loading card-100-width">
                    <div class="card-body">
                        По запросу <b>"{{search.trim()}}"</b> ничего не найдено.
                        <img src="../img/oops1.jpg" >
                    </div>
                </div>
            </div>
            <div class="row loading" v-show="loading" >
                <div class="card card-100-width">
                    <div class="card-body">
                        <div class="loading-text">
                            {{loadingMess}}
                        </div>
                        <div class="boxLoading"></div>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
    import ShowListItem from '@/comp/ShowListItem'

    export default {
        data() {
            return {
                showsList: [],
                searchQuery: ' ',
                search: '',
                loading: true,
                loadingMessArr: ["[A MEME]", "Suh dud", "PK Load Ω", "Generating terrain...", "Ready Player One", "Did they just walk up slowly and load?", "i solemnly swear that i am up to no good", "Switching sides", "Dispatching carrier pigeons", "Is this thing on..?", "Error 404: Joke Not Found", "We at pumpkin hill, you ready?", "Preparing Final Form", "ULTIMATE IS READY!", "Activating Witch Time...", "Insert Coin to Continue", "spinning to win", "Entering cheat codes", "Rushing B", "Pressing random buttons", "Cheat Code Activated", "Resetting Run", "Removing pen from pineapple", "Caution: Contents Spicy", "Good News Everyone!", "Resurrecting dead memes", "Clicking circles (to the beat!)", "Building Lore", "We don't need a healer for this, right?", "Wubba Lubba Dub Dub", "Scaling Bananas", "l o a d i n g a e s t h e t i c s"],
                loadingMess:'Loading Lines in 2k17 LUL'
            }
        },
        components: {
            ShowListItem
        },
        created() {
            this.refreshList()
        },
        watch: {
            search: function(value) {
                if (value == '') {
                    this.searchQuery = ' ';
                } else{
                    this.searchQuery = value;
                }
            },
            loading: function (){
                var rand = Math.random() * this.loadingMessArr.length;
                rand = Math.floor(rand);
                
                this.loadingMess = this.loadingMessArr[rand];
            }
        },
        methods: {
            refreshList: function() {
                this.loading = true;
                let params = {
                    "jsonrpc": "2.0",
                    "method": "shows.Search",
                    "params": {
                        "query": this.searchQuery
                    },
                    "id": 1
                };
                this.$http.post(
                        'https://api.myshows.me/v2/rpc/',
                        params
                    )
                    .then(response => {
                        this.showsList = response.body.result;
                        this.loading = false;
                    });
            },
            clearSearch(){
                this.searchQuery=' ';
                this.refreshList();
                this.search = '';
            }    
        }
    }

</script>

<style>
    .loading-text{
        font-size: 22px;
    }
    .boxLoading {
        width: 50px;
        height: 50px;
        margin:30px auto;
        margin-bottom: 50px;
        position: relative;
    }
    
    .boxLoading:before {
        content: '';
        width: 50px;
        height: 5px;
        background: #000;
        opacity: 0.1;
        position: absolute;
        top: 59px;
        left: 0;
        border-radius: 50%;
        animation: shadow .5s linear infinite;
    }
    
    .boxLoading:after {
        content: '';
        width: 50px;
        height: 50px;
        background: #007bff;
        animation: animate .5s linear infinite;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 3px;
    }
    
    @keyframes animate {
        17% {
            border-bottom-right-radius: 3px;
        }
        25% {
            transform: translateY(9px) rotate(22.5deg);
        }
        50% {
            transform: translateY(18px) scale(1, 0.9) rotate(45deg);
            border-bottom-right-radius: 40px;
        }
        75% {
            transform: translateY(9px) rotate(67.5deg);
        }
        100% {
            transform: translateY(0) rotate(90deg);
        }
    }
    
    @keyframes shadow {
        0%,
        100% {
            transform: scale(1, 1);
        }
        50% {
            transform: scale(1.2, 1);
        }
    }
    
    .loading {
        animation: loading .3s forwards
    }
    
    @keyframes loading {
        from {
            transform: translateY(-15px);
            opacity: 0;
        }
        to {
            opacity: 1;
            transform: none;
        }
    }
    
    .card-100-width {
        width: 100%;
        text-align: center;
        font-size: 35px;
    }

</style>



// WEBPACK FOOTER //
// src/comp/ShowsList.vue?8d0ddb24